var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "session-fade" } }, [
        _vm.showSession403Dialog
          ? _c("div", { staticClass: "session-overlay" }, [
              _c(
                "div",
                {
                  staticClass: "session-modal",
                  attrs: { role: "dialog", "aria-modal": "true" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "session-modal-icon" },
                    [
                      _c("icon-clock-timer", {
                        attrs: { size: 44, color: "#F59E0B" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h3", { staticClass: "session-modal-title" }, [
                    _vm._v("Session Expired"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "session-modal-desc" }, [
                    _vm._v("\n          Your session has expired. Click "),
                    _c("strong", [_vm._v("Continue")]),
                    _vm._v(
                      " to refresh your session and stay on this page, or "
                    ),
                    _c("strong", [_vm._v("Cancel")]),
                    _vm._v(" to go to the login page.\n        "),
                  ]),
                  _vm._v(" "),
                  _vm.session403Error
                    ? _c("p", { staticClass: "session-modal-error" }, [
                        _vm._v(_vm._s(_vm.session403Error)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "session-modal-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "session-btn session-btn--cancel",
                        attrs: { disabled: _vm.session403Loading },
                        on: { click: _vm.onSession403Cancel },
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "session-btn session-btn--continue",
                        attrs: { disabled: _vm.session403Loading },
                        on: { click: _vm.onSession403Continue },
                      },
                      [
                        _vm.session403Loading
                          ? _c("span", { staticClass: "session-spinner" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.session403Loading ? "Refreshing…" : "Continue"
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }